import React from "react";
import HeartSvg from "../../../icons/HeartSvg";
import { cn } from "../../lib/utils";
interface ResidentialPropertyCardProps {
  className?: string;
  subAssetType?: string;
  tag?: string;
  price?: string;
  address?: string;
  auctionDate?: string;
  bankName?: string;
  bankLogo?: React.ReactNode;
  propertyId?: string;
  imageLink?: string;
  propertyLink?: string;
  propertyDateType?: string;
}

import { Button } from "../ui/button";

export const ResidentialPropertyCard = ({
  className,
  subAssetType,
  tag,
  price,
  address,
  auctionDate,
  bankName,
  bankLogo,
  propertyId,
  imageLink,
  propertyLink,
  propertyDateType,
}: ResidentialPropertyCardProps) => {
  return (
    <a href={propertyLink} className={`hover:drop-shadow-sm `}>
      {/* IMAGE part */}
      <div className="flex w-full clip-path-webClipPolygonTopLeft  relative">
        <img className="w-full" src={imageLink} alt="" />
        <div
          className={cn(
            "absolute uppercase",
            tag === "featured"
              ? "font-openSans text-web-body-sm text-center text-brand-textBlack font-normal leading-6 bg-brand-lightBlue w-[191px] pl-14 py-2 h-[41px] left-1"
              : tag === ""
              ? ""
              : "font-openSans text-web-body-sm text-center text-[#FF752C] font-normal leading-6 bg-[#FEECE6] w-[191px] pl-14 py-2 h-[41px] left-1"
          )}
        >
          {tag}
        </div>
        <div className="absolute left-[15px] bottom-[11px]">
          <HeartSvg height="29px" width="29px" bgColor="#FFFFFF"></HeartSvg>
        </div>
      </div>

      <div className="border-[#D1D0D0] border-[1px]">
        {/* Text */}
        <div className="pl-[13px] pr-[18px] pt-[6px] pb-[8px] flex ">
          <div className="pt-4">
            <p className="font-openSans capitalize font-normal text-mobile-body-lg lg:text-web-subheading leading-[27px] text-brand-textBlack">
              {subAssetType}
            </p>

            <p className="font-openSans capitalize font-normal text-web-body-sm  leading-[16px] text-brand-textGrey mt-[3px]">
              {address}
            </p>
          </div>
          <p className="font-openSans font-semibold text-web-subheading leading-6 mt-4 lg:mt-0 lg:leading-[59px] text-brand-textBlack text-nowrap ml-auto">
            {propertyDateType === "undated" ? "Contact Us" : `₹ ${price}`}
          </p>
        </div>
        {/* Border */}
        <div className="border-t-[1px] border-[#D1D0D0]"></div>

        {/* Auction Date */}

        <div className="pl-[13px] pr-[18px] items-center flex py-[13px] mt-2 w-[230px] mid:w-[258px]  bg-gradient-to-r from-[#FEECE6] to-white rounded-tr-lg rounded-br-lg">
          <p className="text-brand-textGrey leading-4 text-web-body-sm font-normal font-openSans">
            Auction date
          </p>
          <p className="text-[#141414] ml-auto text-web-body-sm font-normal font-openSans leading-4">
            {propertyDateType === "undated"
              ? "Coming Soon"
              : propertyDateType === "private_treaty"
              ? "Private Treaty"
              : auctionDate}
          </p>
        </div>
        {/* Bank */}
        <div className="flex items-center gap-x-[9px] mx-auto  h-[65px] pl-[13px] pr-[18px]">
          <div>{bankLogo}</div>

          <p className="text-[#000000] items-center capitalize text-web-body-md font-semibold font-openSans leading-4 ">
            {bankName}
          </p>

          <Button
            variant={"outline"}
            size={"custom"}
            className="h-[25px] w-[118px] rounded-[28px] ml-auto gap-x-2"
          >
            {" "}
            <div className="bg-[#FF752C] h-[5px] w-[5px] rounded-full "></div>
            <p className="font-openSans font-normal text-web-body-sm leading-[18px] text-brand-textGrey tracking-wider">
              ID {propertyId}
            </p>
          </Button>
        </div>
      </div>
    </a>
  );
};
